<script lang="ts">
  import { link } from "svelte-spa-router";
  import TextNew from "../TextNew.svelte";

  export let title: string;
  export let href: string;
</script>

<a use:link {href}>
  <div class="container">
    <div class="text">
      <TextNew as="span" size="m" weight="medium">{title}</TextNew>
    </div>
    <div class="icon">
      <slot name="icon" />
    </div>
  </div>
</a>

<style>
  a {
    text-decoration: none;
  }

  .container {
    display: flex;
    align-items: center;
  }

  .text {
    padding: 3px 0;
  }

  .icon {
    width: 24px;
    height: 24px;
    color: var(--rk-text-dark);
    padding: 2px 0;
  }
</style>
